import { forwardRef, useMemo } from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { TextInputBase } from '../TextInput/TextInputBase';
import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const NumericInput = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    autoInsertCommas = true,
    allowDecimal,
    allowNegative,
    decimalMaxLength,
    maxLength,
    value,
    className,
    ...rest
  } = props;
  const maskDetails = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: Boolean(autoInsertCommas),
    thousandsSeparatorSymbol: ',',
    allowDecimal: Boolean(allowDecimal),
    decimalSymbol: '.',
    decimalLimit: decimalMaxLength,
    integerLimit: maxLength,
    requireDecimal: false,
    allowNegative: Boolean(allowNegative),
    allowLeadingZeroes: true
  };
  const maskingRules = {
    guide: true,
    mask: createNumberMask(maskDetails),
    unmask: [',']
  };
  const effectiveClassName = useMemo(() => clsx(['ids-numeric-input', className]), [className]);
  return /*#__PURE__*/_jsx(TextInputBase, {
    className: effectiveClassName,
    masking: maskingRules,
    value: value,
    ref: ref,
    ...props
  }, JSON.stringify(maskDetails));
});
NumericInput.displayName = 'NumericInput';